export enum desktopSettingPanelAssetConfig {
    settingIconImage = "assets/desktopSettingPanel/setting_icon.png",
    soundIconImage = "assets/desktopSettingPanel/sound_icon.png",
    autoplayIconImage = "assets/desktopSettingPanel/autoplay_icon.png",
    turboIconImage = "assets/desktopSettingPanel/turbo_icon.png",
    crossButtonJson = "assets/desktopSettingPanel/cross_btn.json",

}